/**
 * D12: Storage Statistics (D-SCAN D-8)
 */

/** Get localStorage usage statistics without direct localStorage access in consumers. */
export function getStorageStats(): {
  usedBytes: number;
  usedMb: string;
  keyCount: number;
} {
  let usedBytes = 0;
  let keyCount = 0;
  try {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key) {
        usedBytes += (localStorage.getItem(key)?.length || 0) * 2; // UTF-16
        keyCount++;
      }
    }
  } catch {

    // localStorage may be unavailable in private browsing
  }
  return {
    usedBytes,
    usedMb: (usedBytes / 1024 / 1024).toFixed(2),
    keyCount
  };
}